import React,{useEffect} from 'react';
import { useRoutes, useNavigate, Navigate } from 'react-router-dom';
import routes from './routes';
// import { Spin } from 'antd';
import {store} from '../stores/index.js';


export default function Routes() {
    const element = useRoutes(renderRoutes(routes));
    return element;
}

function renderRoutes(routes) {
    // console.log(routes)
    return routes.map((item)=>{
        // console.log(item)
        let res = { ...item };
        if (!item?.path) return;

        // component
        if (item?.component) {
            const Component = React.lazy(item.component);
            // console.log(item.component)
            // res.element = (<React.Suspense fallback={<Spin size="large" />}>
            res.element = (<React.Suspense>
                <BeforeEach route={item}>
                    <Component />
                </BeforeEach>
            </React.Suspense>);
        }

        // 子路由
        if (item?.children) {
            res.children = renderRoutes(item.children);
        }

        // 重定向
        if (item?.redirect) {
            res.element = (
                <Navigate to={item.redirect} replace />
            )
        }

        return res;
    })
}

//劫持路由
function BeforeEach(props) {
    const navigate = useNavigate();

    if (props?.route?.meta?.title) {
        document.title = props.route.meta.title;
    }
    useEffect(()=>{
        if(props?.route?.meta?.needLogin){
            console.log("判断是否有登录")
            let token = localStorage.getItem('token')||'';
            let user = JSON.parse(localStorage.getItem('user')||'{}');
            // if(!user.member_info||!user.member_info.name){
            if(token===''){
                console.log("未登录");
                localStorage.clear();
                navigate("/login",{replace:true});
                return;
            }else if(token!==''&&user.title === undefined){
                console.log("未完善资料");
                navigate("/register2",{replace:true});
                return;
            }else{
                // console.log("已登录")
            }
        }
    },[props])

    return <div>
        {props.children}
    </div>
}